module.exports = __webpack_public_path__ + "static/media/czas.bf3dd522.svg";